import React from 'react';
import { useTranslation } from 'react-i18next';
import { VersionComponent } from 'react-lib/dist/components-es';
import styles from './ApplicationTitle.module.scss';
import Connector from '../../../agent';

function ApplicationTitle() {
  const { api } = Connector;
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.title}>
        <h1>
          {t('application.title')}
          {window.REACT_APP_HEADER_SUFFIX && (
            <span style={{ color: 'red' }}>{window.REACT_APP_HEADER_SUFFIX}</span>
          )}
        </h1>
      </div>
      <div className={styles.version}>
        <VersionComponent api={api} />
      </div>
    </>
  );
}

export default ApplicationTitle;
